import { Brand } from 'constants/brand';
import lockImage from 'assets/lock.png';

export const RESET_PASSWORD_BACKGROUND_CONFIG = {
  [Brand.FM]: lockImage,
  [Brand.GP]: lockImage,
  [Brand.DAY1]: lockImage,
};
